import getThreadId from '@/lib/threads/getThreadId.js';
import normalizeThreadTimestamp from '@/lib/threads/normalizeThreadTimestamp.js';
import toThreadTimestampMs from '@/lib/threads/toThreadTimestampMs.js';

const OPTIMISTIC_THREAD_CARRYOVER_MS = 45000;

const getOptimisticCarryoverThreads = ({ incomingThreads = [], existingThreadsById = {} }) => {
  const incomingThreadIds = new Set((incomingThreads || []).map((thread) => getThreadId(thread)).filter(Boolean));
  const nowMs = Date.now();

  return Object.values(existingThreadsById || {}).filter((thread) => {
    const threadId = getThreadId(thread);

    if (!threadId) {
      return false;
    }

    if (incomingThreadIds.has(threadId)) {
      return false;
    }

    if (normalizeThreadTimestamp(thread?.archivedAt || thread?.archived_at)) {
      return false;
    }

    const optimisticCreatedAtMs = toThreadTimestampMs(thread?.optimisticCreatedAt);

    if (!Number.isFinite(optimisticCreatedAtMs)) {
      return false;
    }

    return nowMs - optimisticCreatedAtMs <= OPTIMISTIC_THREAD_CARRYOVER_MS;
  });
};

export default getOptimisticCarryoverThreads;
